import React, { useEffect } from "react";
import styled from "styled-components";
import { Modal, Dropdown, Form } from "antd";
import { Formik } from "formik";
import ButtonWrapper from "./ButtonWrapper";
import { useSelector, useDispatch } from "react-redux";
import postQrInitManualTransaction, {
  postIdrCreateTransaction,
} from "../redux/actions/postQrInitManual";
import { useNavigate, useParams } from "react-router-dom";
import { language } from "../utils/language";
import { CloseCircleOutlined } from "@ant-design/icons";
const StyledWrapper = styled(Modal)`
  /* .ant-modal-close-x {
    display: none;
  } */
  .ant-modal-body {
    padding: 10px 20px 10px 20px;
    p {
      font-size: 13px;
      font-weight: 600;
    }
  }
  .ant-modal-content,
  .ant-modal-header {
    border-radius: 10px;
  }
  .warning-text {
    font-size: 25px !important;
    font-weight: bold;
    color: #b8321f;
  }
`;

const WarningModal = (props) => {
  const dispatch = useDispatch();
  const navigation = useNavigate();
  const params = useParams();

  const warningModalState = useSelector((state) => state.warningModalReducer);
  const { data, modalShow } = warningModalState;

  const qrInitManualState = useSelector(
    (state) => state.postQrInitManualReducer
  );
  const { error, isLoading } = qrInitManualState;
  const { lang } = useSelector((state) => state.languageSelectorReducer);

  const acceptWarningHandle = () => {
    dispatch(postQrInitManualTransaction(data, navigation, params.id));
  };

  return (
    <StyledWrapper {...props}>
      <div className="w-100 d-flex justify-content-center align-items-center flex-column">
        <span className="warning-text mb-4">
          {language[lang].warningModal.WARNING}
        </span>
        <p className="text-center">{language[lang].warningModal.FIRST_LINE}</p>
        <p className="text-center mb-0">
          {language[lang].warningModal.SECOND_LINE}
        </p>
        <ButtonWrapper
          border={true}
          size="middle"
          bgColor="#003363"
          color="#fff"
          htmlType="submit"
          className="w-50 mt-4"
          text={language[lang].warningModal.OK}
          loading={isLoading}
          type="primary"
          onClick={acceptWarningHandle}
        />
      </div>
    </StyledWrapper>
  );
};

export default WarningModal;
